export const APP_ROUTES = {
  GIFTCARD_CHECKOUT: '/presentkort',
  GIFTCARD_CONFIRMATION: '/giftcard/confirmation',
  WELLNESSCARD_CHECKOUT: '/friskvardskort',
  ASSOCIATION_PAGES: '/bransch-organisationer',
} as const;
